import { userService } from "../_services";
import { router } from "../router/index";

const loginUserInfo = localStorage.getItem("loginUserInfo")
  ? JSON.parse(localStorage.getItem("loginUserInfo"))
  : null;
const userCognitoInfo = loginUserInfo ? loginUserInfo.cognito : null;

const user = userCognitoInfo;
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

const actions = {
  login({ dispatch, commit }, { username, password }) {
    commit("loginRequest", { username });
    userService
      .loginCognitoUser(username, password)
      .then(async user => {
        if (user.role_id && user.role_id !== '') {
          await userService.setLoginUser(user);
          commit("loginSuccess", user);
          router.push("/");
        } else {
          router.push("/no-permission-given");
        }
      })
      .catch(error => {
        var alertMsg = "Login failed, username or password is incorrect";
        commit("loginFailure");
        alert(error.message ? error.message : alertMsg);
        dispatch("alert/error", error, { root: true });
      });
  },
  logout({ commit }) {
    userService.logout();
    commit("logout");
  }
};

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
    // set current state
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = { loggedIn: false };
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
  registerRequest(state, user) {
    state.status = { registering: true };
  },
  registerSuccess(state, user) {
    state.status = {};
  },
  registerFailure(state, error) {
    state.status = {};
  }
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations
};
